import React, { useContext, useEffect, useRef, useState } from 'react';
import style from './Home.module.css';
import icons from '../../icons';
import Calendar from './Calendar/Calendar';

import Lottie from 'lottie-react';
import checkmark from '../../lottieAnimations/checkmark.json';

import { updateDoc, doc } from "firebase/firestore";

import { Swiper, SwiperSlide } from 'swiper/react';
// import SwiperCore, { EffectFlip, Autoplay  } from 'swiper';
import 'swiper/swiper-bundle.css';

import { AppContext } from '../../AppContext';
import Today from './Today/Today';
import Grades from './Grades/Grades';
import Popup from '../Popup/Popup';
import IconButton from '../Buttons/IconButton/IconButton';
import TextButton from '../Buttons/TextButton/TextButton';
import Classmates from './Classmates/Classmates';
import { db } from '../../firebase';
import { Reorder } from 'framer-motion';


// SwiperCore.use([ EffectFlip, Autoplay ]);

Date.prototype.addDays = function(days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

let sectionsTouchInterval;

const Home = ({ loading, showPremiumPopup }) => {
    const { user, setPage: setGlobalPage, sectionsOrder, updateSectionOrder: setSectionsOrder, editingSectionsOrder, setEditingSectionsOrder } = useContext(AppContext);

    const pageSwiper = useRef();
    const mainContent = useRef();

    const [page, setPage] = useState(0);
    const [viewingClass, setViewingClass] = useState(false);
    const [showInvitePopup, setShowInvitePopup] = useState({ show: false, copied: false });

    const swipePage = index => {
        setPage(index);
        pageSwiper.current.swiper.slideTo(index);
    };

    if (loading)
        return <main className={ style.main }>
            <section className={ style.topSection } style={{ height: viewingClass && "0" }}>
            <img src={  `https://eu.ui-avatars.com/api/?name=?&background=d86c07&rounded=true&format=svg&color=fff` } className={ style.avatar }></img>
            <div className={ style.topHeaders }>
                <h3>Utente</h3>
                <h4>Ciao, utente</h4>
            </div>
        </section>
        <section className={ style.pageChoices } style={{ height: viewingClass && "0", marginBottom: !viewingClass && "1rem" }}>
            <div className={ [style.pageChoice, style.loading].join(" ") }>
                <h4>Oggi</h4>
            </div>
            <div className={ [style.pageChoice, style.loading].join(" ") }>
                <h4>Eventi</h4>
            </div>
            {/* <div className={ [style.pageChoice, style.loading].join(" ") }>
                <h4>Voti</h4>
            </div> */}
            <div className={ [style.pageChoice, style.loading].join(" ") }>
                <h4>Classe</h4>
            </div>
        </section>
        <section className={ style.mainContent } ref={ mainContent } style={{ height: viewingClass && "100vh" }}>
            <Today loading={ true } />
        </section>
        </main>

    return <main className={ style.main } onClick={ () => setEditingSectionsOrder(false) }>
        {  (navigator.clipboard || navigator.canShare) && user && <Popup 
            onClick={ () => setShowInvitePopup({ show: false, copied: false }) }
            show={ showInvitePopup.show } 
            text="Invita i tuoi compagni di classe!" 
            icon={ icons.invite_orange_icon }
            buttons={ <>
                <IconButton icon={ icons.send_white_icon } background="linear-gradient(to left, rgb(150, 85, 1), rgb(255, 115, 0))" text="Condividi" style={{ width: "60%", marginLeft: "auto", marginRight: "auto", padding: ".5rem" }} onClick={ async () => {
                    // navigator.clipboard.writeText(`https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}`);
                    await navigator.share({
                        text: "Unisciti anche tu a SchoolDiary, il diario digitale condiviso con tutta la tua classe!",
                        url: `https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}`,
                    });
                } } />
                <IconButton icon={ icons.copy_to_clipboard_icon } background={ showInvitePopup.copied ? "linear-gradient(to left, rgb(10, 107, 2), rgb(5, 209, 56))" : "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" } text={ showInvitePopup.copied ? "Link copiato" : "Copia link" } style={{ width: "60%", marginTop: "1rem", marginLeft: "auto", marginRight: "auto", padding: ".5rem" }} onClick={ e => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(`https://school-diary-app.netlify.app/login?school=${user.school}&class=${user.class}`);
                    setShowInvitePopup({ show: true, copied: true });
                } } />
            </> } 
        /> }
        <section className={ style.topSection } style={{ height: viewingClass && "0" }}>
            <img src={ user?.profilePicture || `https://eu.ui-avatars.com/api/?name=${user?.username}&background=d86c07&rounded=true&format=svg&color=fff` } referrerPolicy="no-referrer" className={ style.avatar } onClick={ () => setGlobalPage({ page: "menu", menuPage: "profile", from: "home" }) }></img>
            <div className={ style.topHeaders }>
                <h3>{ user?.username ?? "Utente" }</h3>
                <h4>Ciao, { user?.username ?? "..." }</h4>
            </div>
            {/* <img src={ icons.notification_icon } className={ style.notificationIcon } onClick={ () => setPage({ page: "menu", menuPage: "notifications", from: "home" }) }></img> */}
            {/* <IconButton text="Invita" icon={ icons.invite_orange_icon } background="linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" style={{ height: "5vh", width: "40vw", marginTop: "1rem" }} textStyle={{ marginTop: "auto", marginBottom: "auto" }} /> */}
            <img src={ icons.invite_orange_icon } className={ style.notificationIcon } onClick={ () => {
                if (user?.premium) setShowInvitePopup({ show: true, copied: false });
                else showPremiumPopup();
            } }></img>
        </section>
        <Reorder.Group axis="x" values={ sectionsOrder.home ?? [] } onReorder={ newOrder => {
            localStorage.setItem("globalSectionsOrder", JSON.stringify({ ...sectionsOrder, home: newOrder }))
            setSectionsOrder({ home: newOrder });
        } } style={{ listStyleType: "none", padding: "0", margin: "0" }}>
            <section className={ style.pageChoices } style={{ height: viewingClass && "0", marginBottom: !viewingClass && "1rem" }}>
                { sectionsOrder.home?.map((section, idx) => <Reorder.Item key={ section } value={ section } dragListener={ editingSectionsOrder }>        
                    <div className={ [style.pageChoice, page === idx && style.selected, editingSectionsOrder && style.editingSectionsOrder].join(" ") } onClick={ () => swipePage(idx) } onTouchStart={ e => {
                        sectionsTouchInterval = setInterval(() => setEditingSectionsOrder(true), 500)
                        e.stopPropagation();
                    } }  onTouchMove={ () => clearInterval(sectionsTouchInterval) } onTouchEnd={ () => clearInterval(sectionsTouchInterval) } >
                        <h4>{ section }</h4>
                    </div>
                </Reorder.Item>) }
            </section>
        </Reorder.Group>
        <section className={ style.mainContent } ref={ mainContent } style={{ height: viewingClass && "100vh" }}>
            {/* <Today mainContent={ mainContent } setViewingClass={ setViewingClass } /> */}
            <Swiper ref={ pageSwiper } onSlideChange={ ({ activeIndex }) => {
                if (!viewingClass)
                    setPage(activeIndex);
                else
                    pageSwiper.current.swiper.slideTo(page);
            } }>
                { sectionsOrder.home?.map(section => {
                    switch (section) {
                        case "Home":
                            return <SwiperSlide key={ section }><Today mainContent={ mainContent } setViewingClass={ setViewingClass } editingSectionsOrder={ editingSectionsOrder } setEditingSectionsOrder={ setEditingSectionsOrder } /></SwiperSlide>;
                        case "Calendario":
                            return <SwiperSlide key={ section }><Calendar /></SwiperSlide>;
                        case "Classe":
                            return <SwiperSlide key={ section }><Classmates /></SwiperSlide>;
                    }
                }) }
                {/* <SwiperSlide><Grades /></SwiperSlide> */}
            </Swiper>
        </section>
    </main>

};

export default Home;